import async from '../../components/async.min'

export default class Extras {
	constructor() { }

	static generateLightboxes(items) {
		items.venobox({
			framewidth: '1336px',        // default: ''
			frameheight: '702px',       // default: ''
			border: '15px',             // default: '0'
			bgcolor: '#fff',         // default: '#ff'
			numeratio: true,            // default: false
			infinigall: true            // default: false
		})

		let adjustControlsLightBox = function (emiter, callback) {
			async.series([
				function (callback) {
					let $wrapper = $('.vbox-overlay')
					let loaderResource = function( elem, callback ){
						let image = new Image()
						image.src = elem.attr('src')

						image.onload = function () {
							callback()
						}
					}
					let currentSrc = ''

					$wrapper.removeClass('init').scrollTop(0)

					if (emiter == 'main') {
						$.each($wrapper.children(':not(.vbox-preloader)'), function(){
							if( !$(this).hasClass('vbox-preloader') && !$(this).hasClass('vbox-title') ){
								$(this).fadeIn()	
							}
						})
					} else{
						currentSrc = $wrapper.find('.vbox-content img').attr('src')
					}

					let controller = setInterval(function () {
						if (emiter == 'main' && $wrapper.find('.vbox-content img').length > 0) {
							loaderResource( $wrapper.find('.vbox-content img'), function(){
								callback(null)
							})
							clearInterval(controller)
						} else if (emiter != 'main' && currentSrc != $wrapper.find('.vbox-content img').attr('src')) {
							loaderResource( $wrapper.find('.vbox-content img'), function(){
								callback(null)
							});
							clearInterval(controller)
						}
					}, 200)
				},
				function (callback) {
					let $wrapper = $('.vbox-overlay'),
							elemRef = $wrapper.find('.vbox-content img'),
							objWidth = elemRef.outerWidth(),
							objHeight = elemRef.outerHeight(),
							objPosLeft = 0,
							objPosTop = 0

					let controls = {
						close: $wrapper.find('.vbox-close'),
						pagination: $wrapper.find('.vbox-num'),
						buttonNext: $wrapper.find('.vbox-next'),
						buttonPrev: $wrapper.find('.vbox-prev'),
						content: $wrapper.find('.vbox-content'),
						title: $wrapper.find('.vbox-title')
					}

					if (window.innerWidth >= 768) {
						objPosLeft = (window.innerWidth - objWidth) / 2
						objPosTop = (window.innerHeight - objHeight) / 2

						controls.close.css({
							'right': String(objPosLeft - controls.close.width()) + 'px'
						})
						controls.buttonNext.css({
							'right': String(objPosLeft - 60) + 'px'
						})
						controls.buttonPrev.css({
							'left': String(objPosLeft - 60) + 'px'
						})
						if (controls.title.text().length > 0) {
							controls.title.css({
								'left': String(objPosLeft) + 'px'
							})
						}
					} else {
						objPosLeft = (window.innerWidth - objWidth) / 2

						if (controls.title.text().length > 0) {
							objPosTop = (window.innerHeight - (objHeight + controls.title.outerHeight())) / 2
						} else {
							objPosTop = (window.innerHeight - objHeight) / 2
						}

						if (objPosTop < 60) {
							objPosTop = 60
						}

						controls.buttonNext.add(controls.buttonPrev).css({
							'top': objPosTop - 40
						});
					}

					controls.close.css({
						'top': window.innerWidth >= 768 ? String(objPosTop - 4) + 'px' : String(objPosTop + 2) + 'px',
					})
					controls.pagination.css({
						'top': String(objPosTop - 40) + 'px',
						'left': String((objPosLeft + (objWidth / 2)) - 25) + 'px'
					})
					controls.content.css({
						'margin-top': window.innerWidth >= 768 ? objPosTop - 3 : objPosTop + 3,
						'margin-bottom': objPosTop
					})

					if (controls.title.text().length > 0) {
						controls.content.css({
							'padding-bottom': controls.title.outerHeight()
						})
						controls.title.css({
							'width': String(objWidth) + 'px'
						})

						if (window.innerWidth >= 768) {
							controls.title.css({
								'top': (objPosTop + objHeight) - 5,
							})
							if (window.innerWidth >= 1024) {
								controls.title.css({
									'top': (objPosTop + objHeight) - 3,
								})
							}
						} else {
							controls.title.css({
								'top': (objPosTop + objHeight) - 15
							})
						}
					}

					setTimeout(function () {
						$wrapper.addClass('init')
					}, 500)

					if (emiter == 'main') {
						$.each($wrapper.children(':not(.vbox-preloader)'), function(){
							if( !$(this).hasClass('vbox-preloader') && !$(this).hasClass('vbox-title') ){
								$(this).fadeIn()	
							}
						})
					} else {
						controls.content.fadeIn('slow')
						if (controls.title.text().length > 0) {
							controls.title.fadeIn('slow')
						}
					}
					callback(null)
				}
			], function (err, results) {
					if (typeof callback == 'function') {
						callback()
					}
				})
		}

		items.on('click', function () {
			adjustControlsLightBox('main', function () {
				let $buttonsNavigation = $('.vbox-next, .vbox-prev')

				$buttonsNavigation.on('click', function () {
					adjustControlsLightBox('navigation')
				})

				document.addEventListener("keydown", function (event) {
					if (event.which == 37 || event.which == 39) {
						adjustControlsLightBox('navigation')
					}
				})
			})
		})

		$(window).resize(() => {
			adjustControlsLightBox()
		})

		$(window).on("orientationchange", () => {
			adjustControlsLightBox()
		})
	}

	static mapFuncionality()
	{
		$('#map').find('.country, .company').hover(
			function(){
				// Mouse enter
				if( $(this).hasClass('country') ){
					if( !$( this ).hasClass('_hover') ){
						$( this ).addClass('_hover');
					}
				} else if( $(this).hasClass('company') ){
					if( !$( this ).hasClass('_hover') ) {
						$(this).addClass('_hover');
					}


					if( $(this).attr('id') == 'grupo_costa' ||
						$(this).attr('id') == 'grupo_meta' ||
						$(this).attr('id') == 'grupo_casanare' ||
						$(this).attr('id') == 'grupo_valle'
					){
						if( !$('#colombia').hasClass('_hover') ) {
							$('#colombia').addClass('_hover');
						}

					} else if( $(this).attr('id') == 'grupo_laredo' ||
						$(this).attr('id') == 'grupo_ica'
					){
						if( !$('#peru').hasClass('_hover') ) {
							$('#peru').addClass('_hover');
						}
					} else if( $(this).attr('id') == 'grupo_chile' ){
						if( !$('#chile').hasClass('_hover') ) {
							$('#chile').addClass('_hover');
						}
					} else if( $(this).attr('id') == 'grupo_saopaulo' ){
						if( !$('#brasil').hasClass('_hover') ) {
							$('#brasil').addClass('_hover');
						}
					}
				}
			},
			function(){
				// Mouse leave
				if( $(this).hasClass('country') ) {
					if ($(this).hasClass('_hover')) {
						$(this).removeClass('_hover');
					}
				} else if( $(this).hasClass('company') ){
					if( $( this ).hasClass('_hover') ){
						$( this ).removeClass('_hover');
					}

					if( $(this).attr('id') == 'grupo_costa' ||
						$(this).attr('id') == 'grupo_meta' ||
						$(this).attr('id') == 'grupo_casanare' ||
						$(this).attr('id') == 'grupo_valle'
					){
						if( $('#colombia').hasClass('_hover') ) {
							$('#colombia').removeClass('_hover');
						}

					} else if( $(this).attr('id') == 'grupo_laredo' ||
						$(this).attr('id') == 'grupo_ica'
					){
						if( $('#peru').hasClass('_hover') ) {
							$('#peru').removeClass('_hover');
						}
					} else if( $(this).attr('id') == 'grupo_chile' ){
						if( $('#chile').hasClass('_hover') ) {
							$('#chile').removeClass('_hover');
						}
					} else if( $(this).attr('id') == 'grupo_saopaulo' ){
						if( $('#brasil').hasClass('_hover') ) {
							$('#brasil').removeClass('_hover');
						}
					}
				}
			}
		);
	}
}


